// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__3rONz","left":"StickyBox_left__1ifOh","right":"StickyBox_right__2i5Jf"};